const EARTH_RADIUS_KM = 6371;
const EARTH_RADIUS_MILES = 3958.762079;
/**
 * @param {number} val
 */
const ToRadian = val => {
  return (Math.PI / 180) * val;
};

/**
 * @param {number} lat1
 * @param {number} long1
 * @param {number} lat2
 * @param {number} long2
 * @param {boolean} isKm
 */
export const getDistanceFromCoords = (lat1, long1, lat2, long2, isKm) => {
  isKm = isKm || false;
  const earthRadiusKm = EARTH_RADIUS_KM;
  const earthRadiusMi = EARTH_RADIUS_MILES;
  const earthRadius = !isKm ? earthRadiusMi : earthRadiusKm;
  return (
    Math.acos(
      Math.sin(ToRadian(lat1)) * Math.sin(ToRadian(lat2)) +
        Math.cos(ToRadian(lat1)) *
          Math.cos(ToRadian(lat2)) *
          Math.cos(ToRadian(long1) - ToRadian(long2)),
    ) * earthRadius
  );
};
